import { LichHocAnh as ILichHocAnh } from '@/services/LichHocAnh';
import { getLichHocAnh, getLop } from '@/services/LichHocAnh/lichhocanh';
import { useState } from 'react';

export default () => {
  const [danhSach, setDanhSach] = useState<ILichHocAnh.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [record, setRecord] = useState<ILichHocAnh.Record>({} as any);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});
  const [filterInfo, setFilterInfo] = useState<any>({});
  const [edit, setEdit] = useState<boolean>(false);
  const [visibleForm, setVisibleForm] = useState<boolean>(false);
  const [dsLop, setDsLop] = useState([]);

  const getLichHocAnhModel = async (donViId?: string) => {
    setLoading(true);
    const response = await getLichHocAnh({ page, limit, cond: {...cond, donViId} });
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total);
    setLoading(false);
  };
  const getDsLop = async (idDonVi?: string) => {
    setLoading(true);
    const response = await getLop(idDonVi)
    const arrLop: any = [];
    arrLop.push(...response?.data?.data?.result);
    setDsLop(arrLop);
    setLoading(false);
  };
  return {
    danhSach,
    record,
    setRecord,
    loading,
    setLoading,
    getLichHocAnhModel,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    setVisibleForm,
    edit,
    setEdit,
    visibleForm,
    getDsLop,
    dsLop
  };
};
